import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { BiMenuAltLeft } from "react-icons/bi";

import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import StepForm from './StepForm';
import LOGO from './../images/logo.png';
import LinearProgress, {
  linearProgressClasses
} from "@mui/material/LinearProgress";

const drawerWidth = 240;
const navItems = ['Home', 'About', 'Contact'];

function Header(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  
  
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800]
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#004668" : "#004668"
    }
  }));

  const [ActiveStep, setActiveStep] = React.useState(1);

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        MUI
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton sx={{ textAlign: 'center' }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const progressBarValPer = 100/7;
  const progressBarVal = progressBarValPer*ActiveStep;
React.useEffect(() => {
  
}, [ActiveStep])

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar component="nav" className='AppBar' >
        <Toolbar >
          <Box sx={{ display: 'flex', justifyContent:'center', width:'100%', flexDirection:'column' }} >
            <a style={{ width: 'fit-content', margin: '0 auto' }} href="https://windowreplacementquote.com"><img src={LOGO} style={{ width:'200px', margin:'0 auto', backgroundColor:'#fff', padding:'0 1rem' }} /></a>
            {
              ActiveStep > 1 &&
              <Box sx={{ 
                maxWidth:'650px',
                width:'100%',
                margin:'10px auto'
              }} >
                <BorderLinearProgress variant="determinate" value={progressBarValPer*(ActiveStep-1)} />
              </Box>

            }
          </Box>
          
        </Toolbar>
      </AppBar>
  
      <Box component="main" sx={{ p: 0 }}>
        <Toolbar />
        <>
          {/* <div className='main-form'>

          </div> */}
    <div style={{ width:'100%' }}>
      <Grid container  justifyContent='center' columns={{ xs: 1, sm: 4, md: 8, lg: 11 }}>
          <Grid item xs={1} sm={4} md={4}  >
            <div style={{ 
              // width:'100%',
              // backgroundColor:'#fff',
              // minHeight:'100%'
             }}>
              <StepForm ActiveStep={ActiveStep} setActiveStep={setActiveStep}/>
             </div>
          </Grid>
        {/* {Array.from(Array(6)).map((_, index) => (
          <Grid item xs={2} sm={4} md={4} key={index}>
            <Item>xs=2</Item>
          </Grid>
        ))} */}
      </Grid>
    </div>
    <div class="footer">
      <ul>
        <li><a href="https://brandaid.netengine.co/privacy-page" target="_blank">Privacy Policy</a></li>
      </ul>
    </div>

        </>
      </Box>
    </Box>
  );
}

Header.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default Header;
